import { EVENT_MAP, sendLogToUWeb } from '@/plugins/umeng.ts'
import { store } from '@/pinia/store'
import { currentDev } from '@/config/env'
import { emojiCheck, isApp } from '@/utils'

// 埋点补充
const embeddingAdd = async (
  eventName: string,
  eventType: number,
  name: string,
  module: string,
  contentId: string,
  content: string,
  origin: string,
  ext?: any,
  index?: number,
) => {
  // eventName 事件名
  // eventType 事件类型 0：页面曝光 1：页面点击
  const storeData = store()
  console.log(index)
  console.log(typeof index)
  const sendData = {
    module: module || '空',
    name: name || '空',
    content_id: contentId || '空',
    content: emojiCheck(content) || '空',
    user_id: storeData.appData.userId || '空',
    origin: origin || '空',
    index: index !== undefined ? (parseInt(index.toString()) + 1)?.toString() : '0',
    device_id: isApp() ? storeData.headerInfo['c-id'] || '空' : '空',
    ext: ext,
  }
  if (ext.delName) delete sendData.name
  if (ext.delName) delete sendData.ext.delName
  if (eventType === 1) {
    sendData['name'] = name
  }
  if (currentDev !== 1) {
    const toastData = {
      eventId: eventName,
      ...sendData,
    }
    console.log('0609上报埋点数据：' + JSON.stringify(toastData))
  }
  sendLogToUWeb(
    EVENT_MAP.BUSINESS_EVENT,
    eventName,
    JSON.stringify({
      ...sendData,
    }),
  )
}

// 屏幕滚动埋点
const pageScrollEmbedding = async (
  eventName: string,
  module: string,
  endTime: number,
  origin: string,
  ext?: any,
) => {
  // eventName 事件名
  const storeData = store()
  const sendData = {
    module: module || '空',
    start_time: storeData.touchStartTime.toString() || '空',
    end_time: endTime || '空',
    user_id: storeData.appData.userId || '空',
    origin: origin || '空',
    device_id: '空',
    ext: ext,
  }
  if (currentDev !== 1) {
    const toastData = {
      eventId: eventName,
      ...sendData,
    }
    console.log('0609上报埋点数据(页面滚动)：' + JSON.stringify(toastData))
  }
  sendLogToUWeb(
    EVENT_MAP.BUSINESS_EVENT,
    eventName,
    JSON.stringify({
      ...sendData,
    }),
  )
}

export { embeddingAdd, pageScrollEmbedding }
